/**
 * @file
 * @author shaoshuai
 */
export default {
    queryString(data) {
        let body = [];
        for (let [key, value] of Object.entries(data)) {
            body.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
        }
        return body.join('&');
    },

    /**
     * 发送POST请求
     *
     * @param {string} url
     * @param {Object} data
     * @param {string} type
     * @return {Promise}
     */
    post(url, data = {}, type = 'form') {
        if (type === 'json') {
            return fetch(url, {
                method: 'POST',
                body: JSON.stringify(data),
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(response => response.json());
        } else {
            return fetch(url, {
                method: 'POST',
                body: this.queryString(data),
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(response => response.json());
        }
    },

    /**
     * 发送PUT请求
     *
     * @param {string} url
     * @param {Object} data
     * @return {Promise}
     */
    put(url, data = {}, type='form') {
        if (type === 'json') {
            return fetch(url, {
                method: 'PUT',
                body: JSON.stringify(data),
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(response => response.json());
        } else {
            return fetch(url, {
                method: 'PUT',
                body: this.queryString(data),
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(response => response.json());
        }
    },

    /**
     * 发送DELETE请求
     *
     * @param {string} url
     * @param {Object} data
     * @return {Promise}
     */
    delete(url, data = {}) {
        let qs = this.queryString(data);
        if (qs !== '') {
            let sep = url.indexOf('?') === -1 ? '?' : '&';
            url = url + sep + qs;
        }
        return fetch(url, {
            method: 'DELETE',
            credentials: 'include'
        }).then(response => response.json());
        // if (type === 'json') {
        //     return fetch(url, {
        //         method: 'DELETE',
        //         body: JSON.stringify(data),
        //         credentials: 'include',
        //         headers: {
        //             'Content-Type': 'application/json'
        //         }
        //     }).then(response => response.json());
        // } else {
        //     return fetch(url, {
        //         method: 'DELETE',
        //         body: this.queryString(data),
        //         credentials: 'include',
        //         headers: {
        //             'Content-Type': 'application/x-www-form-urlencoded'
        //         }
        //     }).then(response => response.json());
        // }
    },

    /**
     * 发送GET请求
     *
     * @param {string} url
     * @param {Object} data
     * @return {Promise}
     */
    get(url, data = {}) {
        let qs = this.queryString(data);
        if (qs !== '') {
            let sep = url.indexOf('?') === -1 ? '?' : '&';
            url = url + sep + qs;
        }
        return fetch(url, {credentials: 'include'}).then(response => response.json());
    },


    /**
     * 上传文件
     *
     * @param {string} url
     * @param {Object} formData
     * @return {Promise}
     */
    postFile(url, formData = {}) {
        return fetch(url, {
            method: 'POST',
            body: formData,
            credentials: 'include',
        }).then(response => response.json());
    }
};



// WEBPACK FOOTER //
// ./src/lib/ajax.js